<template>
    <div class="w-full mb-[16px]">
        <CustomTable :data="exceptions" :columnsCustom="columnn" :load="table_load">
            <template #other-filter>
                <div class="flex items-center gap-x-[8px]">
                    <button v-on:click="getData('refresh')" :disabled="table_load" class="size-[35px] border rounded-xl flex items-center justify-center">
                        <RefreshCw color="#2b2b2b" :size="16" strokeWidth="1.3" :class="{'animate-spin':actu_load}"/>
                    </button>

                    <button :class="['h-[35px] px-[12px] rounded-xl border flex items-center font-light',{'bg-gray-100':!(toSend.start && toSend.start)}]" @click="reset">
                        Mois
                    </button>

                    <button :class="['h-[35px] px-[12px] text-[#fa3232] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':toSend.filter == 'a'}]" @click="type_filtering('a')">
                        <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                        Absences
                    </button>

                    <button :class="['h-[35px] px-[12px] text-[#fa9832] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':toSend.filter == 'r'}]" @click="type_filtering('r')">
                        <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                        Rétards
                    </button>

                    <button :class="['h-[35px] text-[#3267fa] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':toSend.filter == 'd'}]" @click="type_filtering('d')">
                        <FlagTriangleLeft :size="16" strokeWidth="1.3"/>
                        Départs anticipés
                    </button>

                    <div class="inline-block relative">
                        <button @click="show_advanced = !show_advanced" :class="['h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light',{'bg-gray-100':show_advanced}]">
                            <SlidersHorizontal color="#2b2b2b" :size="16" strokeWidth="1.3"/>
                            Période
                        </button>
                        <Transition @before-enter="beforeEnterBox" @enter="enterBox" @leave="leaveBox">
                            <div v-if="show_advanced" id="advanced-filter" class="flex items-center gap-x-[12px] text-black font-light rounded-3xl p-6 shadow bg-white border absolute top-[120%] left-1/2 z-10">
                                <div class="flex items-center gap-x-[8px]">
                                    <label for="début" class="font-light">Début:</label>
                                    <input type="date" v-model="toSend.start" name="début" class="h-[35px] w-[130px] cursor-pointer p-3 rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                </div>
                                <div class="flex items-center gap-x-[8px]">
                                    <label for="fin" class="font-light">Fin:</label>
                                    <input type="date" v-model="toSend.end" name="début" class="h-[35px] p-3 w-[130px] cursor-pointer rounded-xl border focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px] placeholder:text-mutedForeground"/>
                                </div>
                                <button v-on:click="getData" :disabled="table_load || actu_load" class="h-[35px] px-[12px] rounded-xl border flex items-center gap-x-[12px] font-light">
                                    Actualiser
                                </button>
                                <button @click="show_advanced = !show_advanced" class="size-[25px] rounded-full border flex items-center justify-center">
                                    <X :size="16" strokeWidth="1.3"/>
                                </button>
                            </div>
                        </Transition>
                    </div>
                </div>
            </template>

            <template #row-cell="slotProps">
                <span v-if="slotProps.cellNumber == 0" class="flex items-center gap-x-[8px]">
                    <span :class="['px-3 py-1 rounded-lg',{'bg-[#fa323232] text-[#fa3232]':slotProps.value.split('T')[1] == 'a'},{'bg-[#fa993229] text-[#fa9832]':slotProps.value.split('T')[1] == 'r'},{'bg-[#c7f3de29] text-[#3267fa]':slotProps.value.split('T')[1] == 'd'}]">
                        {{ slotProps.value.split('T')[0] }}
                    </span>
                </span>
                <span v-else-if="slotProps.cellNumber == 1">
                    {{ formatDate(slotProps.value) }}
                </span>
                <span v-else-if="slotProps.cellNumber == 2">
                    <div class="flex items-center gap-x-[6px]">
                        <div class="size-[30px] rounded-full flex items-center justify-center bg-[#3474f4] text-white font-semibold">{{ slotProps.value.split('/')[0].trim()[0] }}</div>
                        <div class="flex flex-col items-start">
                            <span class="text-[12px]">{{ slotProps.value.split('/')[0] + " " + slotProps.value.split('/')[1] }}</span>
                            <!-- <span class="underline font-extralight text-[11px]">{{ slotProps.value.split('/')[2] }}</span> -->
                        </div>
                    </div>
                </span>
                <span v-else-if="slotProps.cellNumber == 3">
                    <span :class="['px-3 py-1 rounded-lg',{'bg-[#d7e6fe] text-[#1e265c]':slotProps.value == '0'},{'bg-[#fcdfc0] text-[#442511]':slotProps.value == '1'},{'bg-[#c7f3de] text-[#183726]':slotProps.value == '2'}]">
                        {{ slotProps.value == '0' && "Non justifiée" }}
                        {{ slotProps.value == '1' && "En cours de validation" }}
                        {{ slotProps.value == '2' && "Justifiée" }}
                    </span>
                </span>
            </template>
        </CustomTable>
    </div>
</template>

<script>

import { initdatable } from '@/js/functions';
import API from '@/service/API';
import Swal from 'sweetalert2';
import CustomTable from './Custom-table.vue';
import {createColumnHelper} from "@tanstack/vue-table";
import { convertirDateEnFrancais } from '@/utils/date-format';
import gsap from "gsap";
import {SlidersHorizontal,RefreshCw,FlagTriangleLeft,X} from "lucide-vue-next";

const columnHelper = createColumnHelper();
const columnsException = [
  columnHelper.accessor(row => `${row.type.label}T${row.type.symbol}`, {
    id: 'exception',
    header: "Type d'exception",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.created_at.split('T')[0], {
    id: 'Date requête',
    header: "Date de l'exception",
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => `${row.user.first_name}/${row.user.last_name}`, {
    id: 'employé',
    header: 'Employé',
    cell: info => info.getValue(),
  }),
  columnHelper.accessor(row => row.state, {
    id: 'state',
    header: 'Status',
    cell: info => info.getValue(),
  }),
];

export default {
    name: 'ExceptionTableComponent',
    components: {
        CustomTable,
        SlidersHorizontal,
        RefreshCw,
        FlagTriangleLeft,
        X
    },
    data() {
        return {
            table_load: false,
            actu_load: false,
            columnn: columnsException,
            show_advanced: false,
            period_filter: 'm',
            toSend: { filter: 'a', start: null, end: null },
            exceptions: []
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        formatDate(date){return convertirDateEnFrancais(date)},
        getData(type = null) {
            this.table_load = true
            if(type == 'refresh') this.actu_load = true;
            API.post('getAllExceptions', this.toSend)
            .then((res) => {
                this.exceptions = res.data.data;
                initdatable('.tableException');
            })
            .catch((error) => Swal.fire('Erreur!!!!',error?.message,'error'))
            .finally(()=>{
                this.table_load = false;
                if(type == 'refresh') this.actu_load = false;
            })
        },
        reset(){
            this.toSend = {...this.toSend, start: null, end: null};
            this.getData();
        },
        type_filtering(fil) {
            if(fil == this.toSend.filter) return;
            if(!(this.toSend.start && this.toSend.end)) return Swal.fire('Erreur!!!!',"Pour effectuer la recherche sur une période, il est obligatoire de choisir la date de début et la date de fin",'error');
            this.toSend.filter = fil;
            this.getData();
        },
        beforeEnterBox(el){
            gsap.set(el, {
                xPercent: -50,
                scale: 0.97,
                y: -10,
                opacity: 0
            });
        },
        enterBox(el, done){
            gsap.to(el, {
                scale: 1,
                y: 0,
                opacity: 1,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
        leaveBox(el, done){
            gsap.to(el, {
                scale: 0.95,
                y: -10,
                opacity: 0,
                duration: 0.15,
                ease: "power2.out",
                onComplete: done,
            });
        },
    }
}

</script>